
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowLeft, Calendar } from 'lucide-react';

interface OrganisationHeaderProps {
  organisation: any;
}

const OrganisationHeader: React.FC<OrganisationHeaderProps> = ({ organisation }) => {
  const navigate = useNavigate();
  
  const goBack = () => {
    navigate('/admin');
  };

  return (
    <div className="mb-6">
      <Button 
        onClick={goBack} 
        variant="ghost" 
        className="flex items-center gap-2 mb-4"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to Admin Dashboard
      </Button>
      
      <div className="flex items-center gap-3">
        <h1 className="text-3xl font-bold">{organisation.name}</h1>
        {organisation.is_test_clone && organisation.data_cutoff_date && (
          <Badge variant="outline" className="text-sm bg-amber-50 text-amber-700 border-amber-300 flex items-center gap-1">
            <Calendar className="h-3.5 w-3.5" />
            Cutoff: {organisation.data_cutoff_date}
          </Badge>
        )}
      </div>
      {organisation.name_dbas && (
        <p className="text-muted-foreground">DBA: {organisation.name_dbas}</p>
      )}
    </div>
  );
};

export default OrganisationHeader;
